import Vue from 'vue';

export default {
  // 银行卡列表
  getBankList() {
    return Vue.axios.get('/api/v1.0/bankCard/selectAccountListByUserId');
  },
  // 银行卡详情
  getBankDetail(bankId) {
    return Vue.axios.get('/api/v1.0/bankCard/getAccountInfoById/' + bankId);
  },
  // 添加银行卡
  addBankInfo(params) {
    return Vue.axios.post('/api/v1.0/bankCard/addBankInfo', params);
  },
  // 设置默认值
  updateAccountDefaultFlag(bankId) {
    return Vue.axios.get('/api/v1.0/bankCard/updateAccountDefaultFlagById/' + bankId);
  },
  // 删除银行卡
  deleteBank(bankId) {
    return Vue.axios.get('/api/v1.0/bankCard/deleteAccountById/' + bankId);
  },

  // 发票列表
  getInvoiceList(params) {
    return Vue.axios.post('/api/v1.0/chanquan/invoice/selectProjectInvoiceList', params);
  },
  // 获取开票信息
  getInvoiceInfo(bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/invoice/toApplyInvoice/' + bidId);
  },
  sendInfo(params) {
    return Vue.axios.post('/api/v1.0/chanquan/invoice/applyInvoice', params);
  },
  getDetail(projectId, bidId, projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/invoice/invoiceDetails/' + projectId + '/' + bidId + '/' + projectType);
  }
};
